import React from "react";

import { Switch } from "~/components/switch";
import { SwitchLabel } from "~/components/switch/label";

interface Props {
	checked: boolean;
	onChange: (checked: boolean) => void;
}

export const IncludeEverythingSwitch = ({ checked, onChange }: Props) => (
	<SwitchLabel className="mt-3 flex items-center gap-2">
		<Switch checked={checked} onCheckedChange={onChange} />
		Include everything
	</SwitchLabel>
);
